<div class="filter full-span">
  <span class="input-group-btn">
    <button class="btn toggle-btn" [class.off]="!jewellery().show" (click)="toggleShowWeapon()"></button>
  </span>
  <span class="filter-body" [class.equipment-filter-from-preset]="jewellery().fromProgressPreset || jewellery().fromClassPreset">
    <app-select style="width: 120px" [disabled]="!jewellery().show" [(ngModel)]="jewellery().jewelleryType" (selectedValueChange)="jewelleryTypeChanged($event)">
      @for (jewelleryType of jewelleryTypes; track jewelleryType) {
        <app-option [value]="jewelleryType.name" [text]="jewelleryType.name" [imgUrl]="imgPrefix + jewelleryType.image!"></app-option>
      }
    </app-select>
    <span class="sep"></span>
    <app-autocomplete
      [options]="jewelleryBaseTypeAutocompleteOptions()"
      [disabled]="!jewellery().show"
      [showOptions]="true"
      [selectedValues]="jewellery().jewelleryBaseTypes"
      (selectedValuesChange)="jewelleryBaseTypesChanged($event);"></app-autocomplete>
    <!-- <span class="sep"></span>
    <app-select-comparator [(ngModel)]="jewellery().rarityComparator" [allowLessThanOrEqual]="false" (selectedValueChange)="updateFilter()" [disabled]="!jewellery().show"></app-select-comparator> -->
    <span class="sep"></span>
    <app-select-rarity [greaterThanOrEqualTo]="true" [includeUnique]="false" [disabled]="!jewellery().show" [(ngModel)]="jewellery().rarity" (selectedValueChange)="minRarityChanged($event);"></app-select-rarity>
    @if (poe2) {
      <span class="sep"></span>
      <app-select style="width: 65px" [disabled]="!jewellery().show" [(ngModel)]="jewellery().unidentifiedTier" (selectedValueChange)="minUnidentifiedTierChanged($event);">
        <app-option [value]="undefined" [text]="'Any'"></app-option>
        <app-option [value]="2" [text]="'≥ T2'"></app-option>
        <app-option [value]="3" [text]="'≥ T3'"></app-option>
        <app-option [value]="4" [text]="'≥ T4'"></app-option>
        <app-option [value]="5" [text]="'T5'"></app-option>
      </app-select>
    }
    <span class="sep"></span>
    <input type="number" placeholder="≥ iLvl" maxlength="2" pattern="[0-9.,]*" inputmode="numeric" step="any" class="form-control minmax" style="min-width: 55px;"
      [disabled]="!jewellery().show"
      [(ngModel)]="jewellery().itemLevel" (change)="updateFilter()">

    @if (poe1) {
      <span class="sep"></span>
      <span class="input-group-btn">
        <button class="btn toggle-button customize-btn" [class.no-conditions]="hasAdvancedConditions === 0" [class.active]="advancedConditionsOpen" [class.disabled]="!jewellery().show"
          (click)="toggleAdvancedOptionsOpen()">
          <span class="icon icon-cog"></span>
          <span class="label">{{ hasAdvancedConditions }}</span>
        </button>
      </span>
    }

    <span class="sep"></span>
    <span class="input-group-btn">
      <app-tooltip-wrapper [right]="true">
        <button class="btn toggle-button customize-btn" [class.no-conditions]="hasHighlightConfig === 0" [class.active]="highlightConfigOpen" [class.disabled]="!jewellery().show"
          (click)="toggleHighlightConfigOpen()">
          <span class="icon icon-equalizer"></span>
          <span class="label">{{ hasHighlightConfig }}</span>
        </button>
        <ng-template #tooltip>Configure which Variants ({{ poe2 ? 'like Unidentified Tiered Jewellery' : 'like Jewellery with Memory Strands'}}) of your chosen Jewellery Type(s) should be shown and highlighted.</ng-template>
      </app-tooltip-wrapper>
    </span>

    <span class="sep"></span>
    <span class="input-group-btn">
      <button class="btn remove-btn" (click)="removeWeaponType()"></button>
    </span>
  </span>
</div>
@if (poe1 && advancedConditionsOpen) {
  <app-advanced-equipment-conditions
    [isArmour]="false"
    [advancedConditions]="jewellery()"
    [isActive]="jewellery().show"
    (updateFilterEmitter)="hasAdvancedConditions = getNumberOfAdvancedConditions(); updateFilter()"></app-advanced-equipment-conditions>
  <div class="clear"></div>
}
@if (navigationEnabled || highlightConfigOpen) {
  <div [class.collapsed]="!highlightConfigOpen">
    <app-my-equipment-highlights
      [equipment]="jewellery()"
      [gearOrJewellery]="jewellery()"
      [jewellery]="jewellery()"
      [equipmentType]="'jewellery'"
      [equipmentIndex]="index()"
      (updateFilterEmitter)="hasHighlightConfig = getNumberOfHighlightConfig(); updateFilter()"></app-my-equipment-highlights>
    <div class="clear"></div>
  </div>
}
